import Fetch from "utils/fetch"

export const buscarUsuarioGrupoFornecedor = () => {
  return Fetch.get("usuario/buscaUsuariosFornecedor").then(({data}) => data)
}
